module.exports = {

    light: {
        name: "Light",

        colors: {
            menuBarBackground: "rgb(227, 227, 227)",
            menuBarText: "rgb(36, 36, 36)",
            panelBackground: "rgb(227, 227, 227)",

            componentBackground: "rgb(204, 204, 204)",
            componentBackgroundHover: "rgb(190, 190, 190)",
            componentBackgroundDisabled: "rgb(200, 200, 200)",
            componentForeground: "rgb(105, 105, 105)",
            componentActive: "rgb(36, 36, 36)",

            textPrimary: "rgb(36, 36, 36)",
            textSecondary: "rgb(87, 87, 87)",
            textHover: "rgb(204, 204, 204)",
            textActive: "rgb(204, 204, 204)",
            textDisabled: "rgb(180, 180, 180)",
        },

    },

    dark: {
        name: "Dark",

        colors: {
            menuBarBackground: "rgb(35, 35, 35)",
            menuBarText: "rgb(235, 235, 235)",
            panelBackground: "rgb(35, 35, 35)",

            componentBackground: "rgb(54, 54, 54)",
            componentBackgroundHover: "rgb(76, 76, 76)",
            componentBackgroundDisabled: "rgb(24, 24, 24)",
            componentForeground: "rgb(112, 112, 112)",
            componentActive: "rgb(202, 202, 202)",

            textPrimary: "rgb(235, 235, 235)",
            textSecondary: "rgb(181, 181, 181)",
            textHover: "rgb(235, 235, 235)",
            textActive: "rgb(54, 54, 54)",
            textDisabled: "rgb(54, 54, 54)",
        },

    },

    // Color scheme from https://metakirby5.github.io/yorha/
    yorha: {
        name: "YoRHa",

        colors: {
            menuBarBackground: "#CCC8B1",
            menuBarText: "#454138",
            panelBackground: "#CCC8B1",

            componentBackground: "#BAB5A1",
            componentBackgroundHover: "#877F6E",
            componentBackgroundDisabled: "#DED8C7",
            componentForeground: "#454138",
            componentActive: "#978F7E",

            textPrimary: "#454138",
            textSecondary: "#454138",
            textHover: "#CCC8B1",
            textActive: "#CCC8B1",
            textDisabled: "#BAB5A6",
        },

        //Optional
        font: {
            fontFamily: "helvetica, sans-serif",
            fontSize: "14px",
            fontWeight: "100",
            inputFontFamily: "ui-monospace, monospace",
        },
    },


};
